import PropTypes from 'prop-types'
import i18n from 'core/common/i18n'
import { translateError } from 'core/common/utils/message'
import If from 'core/components/If'

function MessageErrorEdit({ message, errors, variations, details }) {
  const commonFields = ['prices', 'sku', 'images', 'stocks', 'ean']

  let fields = errors[0] || []
  const fieldsDetails = details ? details[0] : []
  let variationsError = []

  if (errors.length > 1) {
    fields = fields.filter(v => !commonFields.includes(v))

    variationsError = errors.map(i => i.filter(v => commonFields.includes(v)))
  }

  return (
    <div>
      <strong>{message}</strong>
      <ul style={{ listStyle: 'none' }} data-testid="fields">
        {fields.map((field, idx) => (
          <li key={`key-${field}-${idx}`} data-testid="field">
            {i18n.t(`product.productLabels.${field}`)}
            <If condition={fieldsDetails && fieldsDetails.length}>
              :&nbsp;<span data-testid="fieldDetails">{translateError(fieldsDetails[idx])}</span>
            </If>
          </li>
        ))}
      </ul>
      {variationsError &&
        variationsError.map((variationError, idx) => {
          const variation = variations[idx]?.customAttributes.map(atribute => atribute.value)
          return (
            <div key={`key-${variation}-${idx}`}>
              <strong>
                {i18n.t('product.VariationMessage', {
                  variation,
                  variations: variationError.map(v => ` ${i18n.t(`product.productLabels.${v}`)}`),
                })}
              </strong>
            </div>
          )
        })}
    </div>
  )
}

MessageErrorEdit.propTypes = {
  message: PropTypes.string.isRequired,
  errors: PropTypes.array,
  variations: PropTypes.array,
}

MessageErrorEdit.defaultProps = {
  errors: [],
  variations: [],
}

export default MessageErrorEdit
